document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom-select-wrapper").forEach((wrapper) => {
    const trigger = wrapper.querySelector(".custom-select-trigger");
    const options = wrapper.querySelector(".custom-select-options");
    const input = wrapper.querySelector('input[type="hidden"]');

    // Toggle dropdown open
    trigger.addEventListener("click", () => {
      // Close other dropdowns
      document
        .querySelectorAll(".custom-select-wrapper.open")
        .forEach((other) => {
          if (other !== wrapper) {
            other.classList.remove("open");
          }
        });

      wrapper.classList.toggle("open");
    });

    // Close dropdown on outside click
    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove("open");
      }
    });

    // Handle selection
    options.querySelectorAll(".custom-select-option").forEach((option) => {
      option.addEventListener("click", () => {
        options
          .querySelectorAll(".custom-select-option")
          .forEach((o) => o.classList.remove("selected"));
        option.classList.add("selected");
        input.value = option.dataset.value;
        trigger.querySelector("p").textContent = option.textContent;

        wrapper.classList.remove("open");

        console.log("[custom-dropdown] selection changed:", option.dataset.value);
        if (typeof updateVariantItem === "function") {
          updateVariantItem();
        } else {
          console.warn("[custom-dropdown] updateVariantItem not found");
        }
      });
    });
  });
});
